import { useState, useRef, useEffect } from 'react';
import { MagnifyingGlass, CaretDown, Check } from '@phosphor-icons/react';

export const SearchableSelect = ({ value, onValueChange, options, placeholder = 'Sélectionner...', searchPlaceholder = 'Rechercher...', testId }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = options.find(o => o.value === value);
  const filtered = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => { setOpen(!open); setSearch(''); }}
        className="w-full flex items-center justify-between bg-[#1E293B] border border-[#334155] rounded-md px-3 h-10 text-sm text-left hover:border-[#2563EB]/50 transition-colors"
        data-testid={testId}
      >
        <span className={selected ? 'text-[#F8FAFC] truncate' : 'text-[#64748B]'}>{selected ? selected.label : placeholder}</span>
        <CaretDown size={14} className="text-[#64748B] flex-shrink-0 ml-2" />
      </button>
      {open && (
        <div className="absolute z-[1200] mt-1 w-full bg-[#0F172A] border border-[#334155] rounded-md shadow-2xl shadow-black/50 overflow-hidden">
          <div className="relative border-b border-[#1E293B]">
            <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={searchPlaceholder}
              className="w-full bg-transparent pl-9 pr-3 py-2.5 text-sm text-[#F8FAFC] placeholder-[#64748B] focus:outline-none"
              data-testid={testId ? `${testId}-search` : undefined}
            />
          </div>
          <div className="max-h-[220px] overflow-y-auto">
            {filtered.length === 0 ? (
              <p className="text-[#64748B] text-sm p-3 text-center">Aucun résultat</p>
            ) : filtered.map(o => (
              <button
                key={o.value}
                type="button"
                onClick={() => { onValueChange(o.value); setOpen(false); }}
                className={`w-full flex items-center justify-between px-3 py-2.5 text-sm text-left transition-colors ${value === o.value ? 'bg-[#2563EB]/20 text-[#F8FAFC]' : 'text-[#94A3B8] hover:bg-[#1E293B] hover:text-white'}`}
                data-testid={testId ? `${testId}-option-${o.value}` : undefined}
              >
                <span className="truncate">{o.label}</span>
                {value === o.value && <Check size={14} className="text-[#2563EB] flex-shrink-0" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
